import { Paginated } from "./types"
import {
  RateCard,
  RateCardDetails,
  RateCardLoading,
  BaseRate,
  Dimension,
  BaseRateRowRecord,
} from "models/ratecard"
import { http } from "api/http"
import { Client } from "models/common"

export const fetchRateCards = async (_key: string, params: any) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.get("rate-cards", { searchParams }).json()
  return res as Paginated<RateCard>
}

export const createRateCard = async (args: Partial<RateCard>) => {
  return http.post("rate-cards", { json: args }).json()
}

export async function patchRateCard(
  pld: Partial<RateCardDetails> & { id: string },
) {
  const { id, ...data } = pld
  const res = await http.patch(`rate-cards/${id}`, { json: data }).json()
  return res as RateCardDetails
}

export const deleteRateCard = async (id: string) => {
  const res = await http.delete(`rate-cards/${id}`)
  return res
}

export const activateRateCard = async (id: string) => {
  const res = await http.put(`rate-cards/${id}/activate`)
  return res
}

export const deactivateRateCard = async (id: string) => {
  const res = await http.put(`rate-cards/${id}/deactivate`)
  return res
}

//

export const fetchRateCard = (_key: string, id: string) => {
  return http.get(`rate-cards/${id}`).json<RateCardDetails>()
}

//

export const fetchLoadings = async (_key: string, id: string) => {
  const searchParams = new URLSearchParams()
  searchParams.set("rateCardId", id)
  const res = await http.get("loadings", { searchParams }).json()
  return res as RateCardLoading[]
}

export const createLoading = async (
  args: RateCardLoading & { rateCardId: string },
) => {
  return http.post("loadings", { json: args }).json() as RateCardLoading
}

export async function patchLoading(
  pld: Partial<RateCardLoading> & { rateCardId: string },
) {
  const { id, ...json } = pld
  const res = await http.patch(`loadings/${id}`, { json }).json()
  return res as RateCardLoading
}

export const deleteLoading = async (id: string) => {
  const res = await http.delete(`loadings/${id}`)
  return res
}

//

export type CreateBaseRatePayload = {
  rateCardId: string
  supplierProductId?: string
  location?: string
}

export const createBaseRate = (json: CreateBaseRatePayload) => {
  return http.post("base-rates", { json }).json()
}

type CreateBaseRateChannelsPayload = {
  rateCardId: string
  channels: string[]
}

export const createBaseRateChannels = (pld: CreateBaseRateChannelsPayload) => {
  const { rateCardId, channels } = pld
  const promises = channels
    .map((channel) => ({
      rateCardId,
      supplierProductId: channel,
    }))
    .map((json) => http.post("base-rates", { json }).json())

  return Promise.all(promises)
}

export const fetchBaseRate = (_key: string, params: string) => {
  const searchParams = new URLSearchParams(params)
  return http.get("base-rates", { searchParams }).json<BaseRate>()
}

export type UpdateBaseRateConfigPayload = {
  baseRateId: string
  dimensions: Dimension[]
}
export const updateBaseRateConfig = (pld: UpdateBaseRateConfigPayload) => {
  const { baseRateId, dimensions } = pld
  return http
    .put(`base-rates/${baseRateId}/config`, { json: { dimensions } })
    .json()
}

export const deleteBaseRate = async (params: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http.delete("base-rates", { searchParams }).json()
  return res
}

type CreateBaseRateRowPayload = {
  baseRateId: string
  row: Omit<BaseRateRowRecord, "id">
}
export const createBaseRateRow = (pld: CreateBaseRateRowPayload) => {
  const { baseRateId, row } = pld
  return http.post(`base-rates/${baseRateId}/data`, { json: { row } }).json()
}

export const deleteBaseRateRow = (pld: {
  baseRateId: string
  rowId: string
}) => {
  const { baseRateId, rowId } = pld
  return http.delete(`base-rates/${baseRateId}/data/${rowId}`).json()
}

export const updateBaseRateRow = (pld: {
  baseRateId: string
  row: BaseRateRowRecord
}) => {
  const { baseRateId, row } = pld
  return http
    .put(`base-rates/${baseRateId}/data/${row.id}`, { json: { row } })
    .json()
}

export const fetchRateCardClients = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http
    .get("rate-cards/available-clients", { searchParams })
    .json()
  return res as Client[]
}
